import { render, staticRenderFns } from "./SystemStatsWidget.vue?vue&type=template&id=4778282c&scoped=true"
import script from "./SystemStatsWidget.vue?vue&type=script&lang=js"
export * from "./SystemStatsWidget.vue?vue&type=script&lang=js"
import style0 from "./SystemStatsWidget.vue?vue&type=style&index=0&id=4778282c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778282c",
  null
  
)

export default component.exports